<template>
    <b-button variant="warning" @click.stop="exportar()">
        <i class="fa fa-file-excel-o mr-2"></i> Exportar
    </b-button>
</template>

<script>
import download from './../../../shared/download'
import PenalidadesServicos from './PenalidadesServicos'

export default {
	props: {
		contrato: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {}
	},

	methods: {
		exportar() {
			this.$store.dispatch('addRequest')
			PenalidadesServicos.exportar(this.contrato.idContrato).then(
				response => {
					if (response) {
						if (response.type === 'application/json') {
							this.$toast.error(
								'Falha ao obter Penalidades',
								'ERROR',
								this.$toastConfig.error
							)
						} else {
							download(
								response,
								`Penalidades_${this.contrato.vcCodigoEstruturado.replace(
									'/',
									'-'
								)}.xlsx`
							)
						}
					}
					this.$store.dispatch('removeRequest')
				}
			)
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
